import React, { Component } from 'react';
import { Segment, Input, Label, Button, Form, Checkbox, Message } from 'semantic-ui-react';
import InsuredContactInfo from './InsuredContactInfo';

class Signature extends Component {

    constructor(props) {
        super(props);

        this.state = {
            signatureConfirmation: false,
        }
    }

    handleSignatureConfirmationChange = (e) => {
        this.setState({ signatureConfirmation: !this.state.signatureConfirmation });
    }

    render() {
        const { signatureConfirmation } = this.state;
        const { saving, readOnly } = this.props;

        const submitDisabled = saving || !signatureConfirmation || this.props.signature === '';

        return (
            <Segment>
                <Label ribbon color='green' content='Sign and submit the application' />
                <InsuredContactInfo
                    onInsuredContactInfoChange={this.props.onInsuredContactInfoChange}
                    insuredFullName={this.props.insuredContactInfo.insuredFullName}
                    insuredPhoneNumber={this.props.insuredContactInfo.insuredPhoneNumber}
                    insuredEmailAddress={this.props.insuredContactInfo.insuredEmailAddress}
                    readOnly={readOnly}
                />
                <Form as='div'>
                    <Form.Field>
                        <label>Signature</label>
                        <Input
                            placeholder='Sign your name, first and last'
                            fluid
                            onChange={this.props.onSignatureChange}
                            value={this.props.signature}
                            disabled={readOnly}
                        />
                    </Form.Field>
                    {this.props.status === 'SUBMITTED' ? (
                        <Message success content='Your application has been submitted' />
                    ) : (
                        <div>
                        <Form.Field>
                            <Checkbox label='Confirm data from all applicable companies is included.' onChange={this.handleSignatureConfirmationChange} disabled={readOnly} />
                        </Form.Field>
                        <Button
                            icon='thumbs up outline'
                            content='Submit'
                            color='green'
                            inverted
                            onClick={() => this.props.onSubmit('SUBMITTED')}
                            disabled={submitDisabled}
                            loading={saving}
                        />
                        </div>
                    )}

                </Form>
            </Segment>
        );
    }

}

export default Signature;